module.exports = __webpack_public_path__ + "static/media/six-telekurs.d61bc120.png";